export const getSubtypeHeader = (subtype) => {
  if (!subtype) return '';
  return subtype.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};